export function fmtMoney(v, currency = 'DOP') {
  if (v == null) return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  try {
    return new Intl.NumberFormat('es-DO', { style: 'currency', currency }).format(n);
  } catch {
    return n.toFixed(2);
  }
}

export function fmtNumber(v) {
  if (v == null) return '—';
  return new Intl.NumberFormat('es-DO').format(Number(v));
}

export function fmtDate(v) {
  if (!v) return '—';
  try {
    return new Date(v).toLocaleDateString('es-DO', { year: 'numeric', month: 'short', day: '2-digit' });
  } catch { return v; }
}

export function fmtDateTime(v) {
  if (!v) return '—';
  try {
    return new Date(v).toLocaleString('es-DO', {
      year: 'numeric', month: 'short', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return v; }
}

export function fromNow(v) {
  if (!v) return '';
  const ms = Date.now() - new Date(v).getTime();
  const sec = Math.round(ms / 1000);
  if (Math.abs(sec) < 60)  return rel(-sec, 'second');
  const min = Math.round(sec / 60);
  if (Math.abs(min) < 60)  return rel(-min, 'minute');
  const hr  = Math.round(min / 60);
  if (Math.abs(hr) < 24)   return rel(-hr, 'hour');
  const day = Math.round(hr / 24);
  return rel(-day, 'day');
}
function rel(n, unit) {
  return new Intl.RelativeTimeFormat('es', { numeric: 'auto' }).format(n, unit);
}

export function statusBadgeClass(status) {
  const map = {
    disponible: 'success',
    reservado:  'info',
    prestado:   'warn',
    rentado:    'primary',
    activo:     'success',
    activa:     'success',
    cotizada:   'muted',
    reservada:  'info',
    pendiente:  'warn',
    en_proceso: 'warn',
    confirmada: 'info',
    devuelto:   'muted',
    devuelta:   'muted',
    completado: 'success',
    cancelado:  'muted',
    cancelada:  'muted',
    parcial:    'warn',
    vencido:    'danger',
    vencida:    'danger',
    con_deuda:  'warn',
    con_dano:   'warn',
    danado:     'danger',
    perdido:    'danger',
    perdida:    'danger',
    retirado:   'muted',
    mantenimiento: 'warn',
    convertida_prestamo: 'muted',
    convertida_renta:    'muted',
  };
  return map[status] || 'muted';
}
